import { createContext, useContext, useState } from "react";

const ClientContext = createContext();


export const ClientProvider = ({ children }) => {
  const [selectedClient, setSelectedClient] = useState(null);
  const [shouldPrefill, setShouldPrefill] = useState(false);

  return (
    <ClientContext.Provider value={{ selectedClient, setSelectedClient, shouldPrefill, setShouldPrefill }}>
      {children}
    </ClientContext.Provider>
  );
};
export const useClientContext = () => useContext(ClientContext);

// export const useClient = () => useContext(ClientContext);